<div *ngIf="!openConfirmation" class="stepper-panel">
    <div class="container m--full-bleed">
      <div class="row m--full-bleed">
        <div class="col-12">
          <div class="form-panel">
            <mat-stepper [orientation]="stepperOrientation" #stepper linear="true">
              <!-- 1. T&C -->
              <mat-step class="stepper-icon" [stepControl]="termsFrmGp">
                <form [formGroup]="termsFrmGp">
                  <ng-template matStepLabel>Terms and Conditions</ng-template>
                  <div>
                    <div #cguContainer class="terms-panel" (scroll)="checkReading()" [innerHTML]="termsContent"></div>
                  </div>
                  <div class="mt-3">
                    <label class="smart-checkbox pb-2">
                      <input type="checkbox" class="form-check-input smart-checks checkmark" formControlName="accepted"
                        required>
                      <span class="ts-s pt-2">Accept Terms and Conditions</span>
                      <span class="checkmark"></span>
                      <p class="c-red1" *ngIf="isTermsSubmitted && termsFrmGp.get('accepted')?.value !== true">Please
                        accept the terms and conditions to move forward.</p>
                    </label>
                  </div>
                  <div class="flex-btn-row pt-2 pb-2">
                    <button class="btn btn-secondary" mat-button matStepperPrevious (click)="goToHome()">Back</button>
                    <button class="btn btn-primary-short" (click)="submitTerms()" mat-button matStepperNext>Next</button>
                  </div>
                </form>
              </mat-step>
              <!-- 2. Add Payor Info -->
              <mat-step>
                <ng-template matStepLabel>Complete Payor Information</ng-template>
                <!-- <epay-lib-employer-payor-validation [baseurl]="baseurl" [clientName]="clientName"
                  [validationType]="validationType" [isEditPayment]="iseditccPayment"
                  [editPayorCollection]="paymentCollection"
                  (validCreditCardPaymentEmitter)="validCCPaymentEmitted($event)">
                </epay-lib-employer-payor-validation> -->

                <payor-validation-common [baseurl]="baseurl" [clientName]="clientName"
                    [validationType]="validationType" [isEditPayment]="iseditccPayment"
                    [editPayorCollection]="paymentCollection"
                    (validCreditCardPaymentEmitter)="validCCPaymentEmitted($event)">
                </payor-validation-common>

              </mat-step>
              <!-- 3. Review & Submit -->
              <mat-step>
                <ng-template matStepLabel>Submit Your Payment</ng-template>
                <!-- <epay-lib-employer-creditcard-submit [baseurl]="baseurl" [creditCardVendorId]="creditCardVendorId"
                  [creditCardDisclaimer]="creditCardDisclaimer" [creditCardPayment]="empCCPayment">
                </epay-lib-employer-creditcard-submit> -->

                <emp-cc-submit [baseurl]="baseurl" [creditCardVendorId]="creditCardVendorId"
                    [creditCardDisclaimer]="creditCardDisclaimer" [creditCardPayment]="empCCPayment">
                </emp-cc-submit>
              </mat-step>
            </mat-stepper>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <epay-lib-common-confirmation *ngIf="openConfirmation" [sender]="confirmationSender"
    [confirmationTitle]="confirmationTitle" [confirmationMessage]="confirmationMessage"
    [confirmationNumber]="confirmationNumber" [goToPrimary]="goToPrimary" [goToPrimaryUrl]="goToPrimaryUrl"
    (confirmationEmitter)="hideConfirmationPage($event)">
  </epay-lib-common-confirmation>